import { useState, useCallback } from 'react'
import type { LinkCreationState, LinkStatus } from '../../types/infrastructure-map'

export interface UseLinkCreationResult {
  state: LinkCreationState
  startLinkCreation: () => void
  selectParent: (endpointId: string) => void
  toggleChild: (endpointId: string) => void
  setLinkType: (type: LinkStatus) => void
  setOpenQuestionText: (text: string) => void
  reset: () => void
}

const initialLinkCreationState: LinkCreationState = {
  isActive: false,
  parentEndpointId: null,
  childEndpointIds: [],
  linkType: null,
  openQuestionText: '',
}

export function useLinkCreation(): UseLinkCreationResult {
  const [state, setState] = useState<LinkCreationState>(initialLinkCreationState)

  const startLinkCreation = useCallback(() => {
    setState({ ...initialLinkCreationState, isActive: true })
  }, [])

  const selectParent = useCallback((endpointId: string) => {
    setState((prev) => ({ ...prev, parentEndpointId: endpointId }))
  }, [])

  const toggleChild = useCallback((endpointId: string) => {
    setState((prev) => {
      const childIds = prev.childEndpointIds.includes(endpointId)
        ? prev.childEndpointIds.filter((id) => id !== endpointId)
        : [...prev.childEndpointIds, endpointId]
      return { ...prev, childEndpointIds: childIds }
    })
  }, [])

  const setLinkType = useCallback((type: LinkStatus) => {
    setState((prev) => ({ ...prev, linkType: type }))
  }, [])

  const setOpenQuestionText = useCallback((text: string) => {
    setState((prev) => ({ ...prev, openQuestionText: text }))
  }, [])

  const reset = useCallback(() => {
    setState(initialLinkCreationState)
  }, [])

  return {
    state,
    startLinkCreation,
    selectParent,
    toggleChild,
    setLinkType,
    setOpenQuestionText,
    reset,
  }
}
